import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '@core/services/translation.service';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base.component';
import { GrpserviceService } from '../../grpservice.service';
import { NewsRequestDto } from '../../category-grp/grp.model';

@Component({
  selector: 'app-add-edit-news-dialog',
  templateUrl: './add-edit-news-dialog.component.html',
  styleUrls: ['./add-edit-news-dialog.component.scss'],
})
export class AddEditNewsDialogComponent
  extends BaseComponent
  implements OnInit
{
  newsForm!: FormGroup;
  isEdit: boolean = false;
  newsId?: number;

  constructor(
    public dialogRef: MatDialogRef<AddEditNewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // when editing we pass news data
    private fb: FormBuilder,
    public translationService: TranslationService,
    private toastrService: ToastrService,
    private newsService: GrpserviceService
  ) {
    super(translationService);
  }

  ngOnInit(): void {
    this.newsForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(500)]],
      description: ['', [Validators.required, Validators.maxLength(1000)]],
      details: ['', [Validators.required]],
      actualDate: ['', [Validators.required]],
    });

    // If data is passed → Edit mode
    if (this.data && this.data.news) {
      this.isEdit = true;
      this.newsId = this.data.news.id;
      this.newsForm.patchValue({
        title: this.data.news.newsTitle,
        description: this.data.news.newsDesc,
        details: this.data.news.newsDetails,
        actualDate: this.data.news.dateActual
          ? new Date(this.data.news.dateActual)
          : '',
      });
    }
  }

  // Getter for easy access in template
  get f() {
    return this.newsForm.controls;
  }

  onSubmit(): void {
    if (this.newsForm.valid) {
      const formData = this.newsForm.value;
      const authObj = JSON.parse(localStorage.getItem('authObj') || '{}');
      const fullName =
        authObj.firstName && authObj.lastName
          ? `${authObj.firstName} ${authObj.lastName}`
          : authObj.userName || '';

      const payload: NewsRequestDto = {
        id: this.isEdit ? this.newsId! : 0,
        newsTitle: formData.title,
        newsDesc: formData.description,
        newsDetails: formData.details,
        dateActual: formData.actualDate,
        createdBy: this.isEdit ? null : fullName,
        updatedBy: this.isEdit ? fullName : null,
        approvedBy: null,
        approvedDate: null,
        approvedStatus: null,
        action: this.isEdit ? 'UPDATE' : 'INSERT',
      };

      const request$ = this.isEdit
        ? this.newsService.UpdateManageNewsRecord(payload)
        : this.newsService.saveNews(payload);

      request$.subscribe({
        next: (res) => {
          this.toastrService.success(
            this.isEdit
              ? 'News updated successfully.'
              : 'News added successfully.'
          );
          this.dialogRef.close(res);
        },
        error: (err) => {
          this.toastrService.error('Failed to save news.');
          console.error(err);
        },
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
